import { useState } from "react";
import { useNavigate } from "react-router-dom";

const ComboBar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const goToCombo = (comboType) => {
    setOpen(false);
    navigate("/bsk-main-product", { state: { comboType } });
  };

  return (
    <>
      {!open && (
        <div className="train-box" onClick={() => setOpen(true)}>
          CLICK TO COMBO
        </div>
      )}

      {open && <div className="combo-backdrop" onClick={() => setOpen(false)} />}

      {open && (
        <div className="combo-modal-card">
          <h4 className="fw-bold text-center mb-2"> Combo Offers</h4>
          <p className="text-muted text-center mb-4">
            Choose the best deal for you
          </p>

          <button
            className="btn btn-primary btn-lg w-100 mb-3"
            onClick={() => goToCombo("MIXED")}
          >
            Mixed Combo
            <div className="small opacity-75">
              Pick multiple products from any category
            </div>
          </button>

          <button
            className="btn btn-success btn-lg w-100 mb-3"
            onClick={() => goToCombo("BULK")}
          >
             Category Special
            <div className="small opacity-75">
              Special bulk offer for one category
            </div>
          </button>

          <button
            className="btn btn-outline-secondary w-100"
            onClick={() => setOpen(false)}
          >
            Close
          </button>
        </div>
      )}
    </>
  );
};

export default ComboBar;
